import { useState, useEffect } from 'react';
import { useEasybase } from 'easybase-react';
import { Button, Card, CardContent, CardActions, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { normalesDatum } from './ZeitFunktionen';

const AktuelleBuchungen = (props) => {
    const [wer] = useState(props.wer);
    const { db, e } = useEasybase();
    const [buchungen, setBuchungen] = useState([]);
    const kursTable = db("KURS");
    const buchTable = db("BUCHUNG");

    const mounted = () => {
        console.log("mounted?");
        kursTable.return().where(
            e.and(
                e.eq('aktiv', true),
                e.eq('sr', props.sr))
        ).limit(100).all()
            .then(kursListe => {
                buchTable.return().where(
                    e.and(
                        e.eq('wer', wer),
                        e.eq('sr', props.sr))
                ).limit(100).all()
                    .then(ebData => {
                        for (var b = 0; b < ebData.length; b = b + 1) {
                            console.log("b:" + ebData[b].wer + " k:" + ebData[b].kursid + "#");
                            for (var k = 0; k < kursListe.length; k = k + 1) {
                                console.log("    check k:" + kursListe[k]._key + "#");
                                if (kursListe[k]._key === ebData[b].kursid) {
                                    ebData[b].name = kursListe[k].name;
                                    ebData[b].datum = kursListe[k].datum;
                                    ebData[b].zeit = kursListe[k].zeit;
                                    console.log("Treffer:" + kursListe[k].name);
                                }
                            }
                        }
                        setBuchungen(ebData);
                    });
            });
    };

    useEffect(() => {
        mounted();
        // eslint-disable-next-line
    }, []);

    const onRemove = async (event) => {
        console.log("onRemove:" + event.currentTarget.value);
        await buchTable.delete().where(e.eq('_key', event.currentTarget.value)).one();
        mounted();
    }

    const useStyles = makeStyles({
        root: {
            width: 300,
            background: 'lightgreen',
            color: 'black',
            borderRadius: 20,
            margin: 10,
            position: 'relative',
        },
        bullet: {
            display: 'inline-block',
            margin: '0 2px',
            transform: 'scale(0.8)',
        },
        title: {
            fontSize: 14,
        },
        pos: {
            marginBottom: 12,
        },
    });
    const classes = useStyles();

    return (
        <Grid style={{ padding: 16 }} container spacing={3}>
            <Grid item sm={12}>
                <Typography variant="body1">{wer}</Typography>
            </Grid>
            <Grid item sm={12}>
                <Typography variant="h4">Aktuelle Buchungen {props.sr === "s"?"Sportarena":"REHA"}:</Typography>
            </Grid>
            {buchungen.map((buch) => <Grid item sm={3}>
                <Card id={buch._key} className={classes.root}>
                    <CardContent>
                        <Typography variant="body1">{buch.name}</Typography>
                        <Typography variant="body1">{normalesDatum(buch.datum)} {buch.zeit}</Typography>
                    </CardContent>
                    <CardActions>
                        <Button value={buch._key} variant="contained" onClick={onRemove}>Ausbuchen</Button>
                    </CardActions>
                </Card>
            </Grid>
            )}
        </Grid>
    );
};
export default AktuelleBuchungen;